module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-regular.6838bc8d.svg";